/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_ImprovingInputs */

const en_privacy_section_3_item_improving = /** @type {(inputs: Privacy_Section_3_Item_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improving our website`)
};

const lv_privacy_section_3_item_improving = /** @type {(inputs: Privacy_Section_3_Item_ImprovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mājaslapas uzlabošana`)
};

/**
* | output |
* | --- |
* | "Improving our website" |
*
* @param {Privacy_Section_3_Item_ImprovingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_improving = /** @type {((inputs?: Privacy_Section_3_Item_ImprovingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_ImprovingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_improving(inputs)
	return en_privacy_section_3_item_improving(inputs)
});